module.exports = __webpack_public_path__ + "assets/img/fuzhang_1.8f75c619.png";